import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Grid, Link } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AssetCard from './AssetCard';

const AssetsAtRisk = ({ assets }) => {
  const navigate = useNavigate();
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ErrorOutlineIcon sx={{ fontSize: 22, color: 'text.secondary' }} />
          <Typography variant="h5" sx={{ fontWeight: 600, fontSize: '1.125rem' }}>
            Assets at Risk
          </Typography>
        </Box>
        <Link
          component="button"
          underline="none"
          onClick={() => navigate('/assets?criticality=Critical')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: 'text.secondary',
            fontSize: '0.875rem',
            fontWeight: 500,
            cursor: 'pointer',
            '&:hover': { color: 'text.primary' },
          }}
        >
          View All
          <ChevronRightIcon sx={{ fontSize: 18 }} />
        </Link>
      </Box>

      <Grid container spacing={2.5}>
        {assets.map((asset) => (
          <Grid size={{ xs: 12, md: 6 }} key={asset.id}>
            <AssetCard asset={asset} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AssetsAtRisk;
